import "./NavBar.css";

const getCGPA = semesters => {

    let total = 0.0;

    let totalCourses = 0

    semesters.forEach(semester => {
        semester.courses.forEach(course => {
            totalCourses++;
            switch (course.courseGrade) {
                case "AA":
                    total += 4;
                    break;
                case "BA":
                    total += 3.5;
                    break;
                case "BB":
                    total += 3;
                    break;
                case "CB":
                    total += 2.5;
                    break;
                case "CC":
                    total += 2;
                    break;
                case "DC":
                    total += 1.5;
                    break;
                case "DD":
                    total += 1;
                    break;
                case "FD":
                    total += 0.5;
                    break;
                default:
                    break;
            }
        } );
    } );

    return Number((total / totalCourses).toFixed(2));

}

export default function NavBar({user, signOut}) {


    return (
        <div id="mainPageNavBar">
        <div id="mainPageNavBar-left">
            <div id="mainPageNavBar-left-logo" className="btn" />
        </div>

        <div id="mainPageNavBar-right">
            <p id="CGPA">CGPA: {getCGPA(user.marks)}</p>
            <div id="mainPageNavBar-right-user" className="btn" onClick={togglePopUp} />

            <div id="user-popup" className="hidden">
                <div id="user-popup-name"> {user && user.name ? user.name : "No Name"} </div>
                <button id="sign-out-btn" onClick={signOut} className="btn">
                    Sign Out
                </button>
            </div>



        </div>
    </div>

    )

}

function togglePopUp() {
    const popup = document.getElementById("user-popup");
    popup.classList.toggle("hidden");
}